import React from 'react';
import css from './Textarea.module.css';

const Textarea = React.forwardRef(({
  className = '',
  ...props
}, ref) => {
  return (
    <textarea
      ref={ref}
      className={`${css.textarea} ${className}`}
      {...props}
    />
  );
});

Textarea.displayName = 'Textarea';

export default Textarea;
